module.exports = __webpack_public_path__ + "fonts/iconfont.66b24340.woff";